<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          {{ $t('audit.title') }}
        </h6>
      </div>

      <Menu/>

      <Search
          :filters="filters"
          :loading="isSearching"
          :monthsInYearDropdown="enums.monthsInYear"
          :yearsDropdown="yearsDropdown"
          @search="getWeeklyCalendarData"/>

      <div class="element-box mt-0">
        <div class="row text-center p-1 d-none d-lg-flex mb-3"
             :style="{
          backgroundColor: 'white',
          color: 'var(--primary)',
          borderRadius: '4px',
          border: '2px solid var(--primary)'
       }">
          <div class="col p-1">Montag</div>
          <div class="col p-1">Dienstag</div>
          <div class="col p-1">Mittwoch</div>
          <div class="col p-1">Donnerstag</div>
          <div class="col p-1">Freitag</div>
          <div class="col p-1">Samstag</div>
          <div class="col p-1">Sonntag</div>
        </div>

        <div v-for="(week, weekIndex) in weeksData" :key="weekIndex" class="row border-bottom-lg mt-lg-2">
          <div v-for="(dayData, dayIndex) in week"
               :key="dayIndex"
               class="col-12 col-lg text-center mb-3 mb-lg-0"
               style="min-height: 100px;">

            <div v-if="dayData !== null">
              <div class="p-1 mb-2 fw-bold"
                   style="background-color: var(--primary); color: white; border-radius: 4px">

          <span class="d-lg-none">
            {{ ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'][dayIndex] }}
          </span>

                {{ dayData.day }}.{{ String(filters.month).padStart(2, '0') }}
              </div>

              <div v-for="audit in dayData.dayData" :key="audit.id" class="border rounded mb-2 shadow-sm bg-white">
                <router-link
                    :to="{ name: 'auditFormUpdate', params: { officeId: audit.office.id, id: audit.id } }"
                    class="text-center p-2 d-block text-decoration-none text-dark">
                  <p class="fw-bold mb-1" style="font-size: 0.85rem;">{{ audit.office.name }}</p>
                  <p class="mb-1 text-muted" style="font-size: 0.8rem;">{{ audit.date }}</p>
                  <p class="mb-0 fw-medium text-primary" style="font-size: 0.8rem;">
                    {{ audit.startTime }} - {{ audit.endTime }}
                  </p>
                </router-link>
              </div>
            </div>

            <div v-else class="d-none d-lg-block h-100" style="background: #f8f9fa; min-height: 100px; opacity: 0.5;"></div>
          </div>
        </div>
      </div>

<!--      <div class="element-box mt-0">-->
<!--        &lt;!&ndash; Header Row &ndash;&gt;-->
<!--        <div class="row text-center p-1"-->
<!--             :style="{-->
<!--          backgroundColor:-->
<!--          'white', color:-->
<!--          'var(&#45;&#45;primary)',-->
<!--          borderRadius: '4px',-->
<!--          border: '2px solid var(&#45;&#45;primary)'}">-->
<!--          <div class="col p-1">Montag</div>-->
<!--          <div class="col p-1">Dienstag</div>-->
<!--          <div class="col p-1">Mittwoch</div>-->
<!--          <div class="col p-1">Donnerstag</div>-->
<!--          <div class="col p-1">Freitag</div>-->
<!--          <div class="col p-1">Samstag</div>-->
<!--          <div class="col p-1">Sonntag</div>-->
<!--        </div>-->

<!--        &lt;!&ndash; Weeks &ndash;&gt;-->
<!--        <div v-for="(week, weekIndex) in weeksData" :key="weekIndex" class="row border-bottom mt-4">-->
<!--          <div v-for="(dayData, dayIndex) in week"-->
<!--               :key="dayIndex"-->
<!--               class="col text-center"-->
<!--               style="min-height: 180px;">-->
<!--            <div v-if="dayData !== null">-->
<!--              <div class="p-1 mb-2" style="background-color: var(&#45;&#45;primary); color: white; border-radius: 4px">-->
<!--                {{ dayData.day }}.{{ String(filters.month).padStart(2, '0') }}-->
<!--              </div>-->
<!--              <div v-for="audit in dayData.dayData" :key="audit.id" class="border mb-2">-->
<!--                <router-link-->
<!--                    :to="{ name: 'auditFormUpdate', params: { officeId: audit.office.id, id: audit.id } }"-->
<!--                    class="text-center p-2 d-block">-->
<!--                  <p style="margin-bottom: 8px;">{{ audit.office.name }}</p>-->
<!--                  <p style="margin-bottom: 5px;">{{ audit.date }}</p>-->
<!--                  <p style="margin-bottom: 3px;">{{ audit.startTime }} - {{ audit.endTime }}</p>-->
<!--                </router-link>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

    </div>
  </PageTemplate>
</template>

<script setup>
import officeAuditService from '@/api/OfficeAudit';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import { getYears } from '@/shared/dropdowns';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import Search from '@/views/App/OfficeAudit/Calendar/CalendarSearch.vue';
import Menu from '@/views/App/OfficeAudit/Menu.vue';
import { onMounted, ref } from 'vue';

const weeksData     = ref([]);
const isLoaded      = ref(false);
const yearsDropdown = ref([]);
const isSearching   = ref(false);
const { enums }     = piniaEnumsStore();

const today             = new Date();
const currentMonthIndex = today.getMonth();

const filters = ref({
  year: yearsDropdown.value.at(-1)?.value || new Date().getFullYear(),
  month: enums.monthsInYear[ currentMonthIndex ].value,
});

async function getWeeklyCalendarData(passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  try {
    const { data } = await officeAuditService.getWeeklyCalendar({ ...(passedFilters ? passedFilters : filters.value) });

    weeksData.value   = data.data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getYears(yearsDropdown);
  await getWeeklyCalendarData();
  isLoaded.value = true;
});

</script>

<style scoped>
@media (min-width: 992px) {
  .border-bottom-lg {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 10px;
  }
}

@media (max-width: 991px) {
  .element-box {
    padding: 10px;
  }
}
</style>